import React, { useEffect, useLayoutEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Link } from "react-router-dom";
import CoustomImg from "../CoustomImg/CoustomImg";
import TruncateText from "../TruncateText/TruncateText";
import { URL } from "../../Redux/common/url";

function FeProduct({ homedata }) {
  const recentProduct = homedata?.feproduct || [];
  const [windowWidth, setWindowWidth] = useState(600);

  useLayoutEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const cards = document.querySelectorAll(".featured-product-card");

    cards.forEach((card) => {
      const field = document.createElement("div");
      field.className = "featured-particles-field";
      card.appendChild(field);

      for (let i = 0; i < 25; i++) {
        const particle = document.createElement("div");
        particle.className = "featured-particle";
        particle.style.setProperty("--x", `${Math.random() * 200 - 100}px`);
        particle.style.setProperty("--y", `${Math.random() * 200 - 100}px`);
        particle.style.animation = `particleFloat ${1 + Math.random() * 2}s infinite ease-in-out`;
        particle.style.animationDelay = `${Math.random() * 2}s`;
        particle.style.left = `${Math.random() * 100}%`;
        particle.style.top = `${Math.random() * 100}%`;
        field.appendChild(particle);
      }
    });
  }, [recentProduct]);

  return (
    <div className="featured-product-slider-container px-1 mt-4 feature-product-new">
      <div className="featured-product-header position-relative overflow-hidden d-flex justify-content-between align-items-center p-2 mb-2">
        <div>
          <h5 className="fw-bold featured-product-text mb-0">FEATURED PRODUCTS</h5>
        </div>
        <div>
          <Link className="text-decoration-none fw-bold featured-product-text" to="/products">
            View all
          </Link>
        </div>

        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
      </div>

      <Swiper
        modules={[Autoplay]}
        spaceBetween={15}
        autoplay={{ delay: 1800, disableOnInteraction: false }}
        loop={true}
        speed={1000}
        breakpoints={{
          320: { slidesPerView: 2 },
          768: { slidesPerView: 4 },
          1024: { slidesPerView: 6 },
        }}
      >
        {recentProduct.map((data, i) =>{ 
                 const productprice = (data.categoryId?.rate*data?.size)+data?.price;
          return(
           
          <SwiperSlide key={i}>
            <Link to={`/product/${data?.pro_sulg}`} className="text-decoration-none">
              <div className="featured-product-card tilt">
                <div className="img-box">
                  <CoustomImg
                    url={URL.API_BASE_URL + data?.featureImage}
                    altkey={data?.title}
                    w1={200}
                    w2={250}
                    h1={160}
                    h2={220}
                  />
                </div>

                <span className="mannu-bhai"></span>
                <span className="mannu-bhai"></span>
                <span className="mannu-bhai"></span>
                <span className="mannu-bhai"></span>

                <div style={{ lineHeight: "0.6" }}>
                  <p>
                    {data?.title?.length > 18
                      ? data?.title.substring(0, 18) + "..."
                      : data?.title}
                  </p>

                  <div className="d-flex align-items-center">
                    <span className="fw-bold color-new-mm">  ₹{productprice}</span>
                    {/* <span className="text-warning fw-bold text-decoration-line-through ms-3">
                    {productprice}
                    </span> */}
                  </div>
                </div>
              </div>
            </Link>
          </SwiperSlide>
          
        )})}
      </Swiper>
    </div>
  );
}

export default FeProduct;





// import React, { useLayoutEffect, useState } from "react";
// import Slider from "react-slick";
// import CoustomImg from "../CoustomImg/CoustomImg";
// import TruncateText from "../TruncateText/TruncateText";
// import { URL } from "../../Redux/common/url";
// import { Link } from "react-router-dom";

// function FeProduct({ homedata }) {
//   const get_home_all_pro = homedata;

//   const recentProduct = get_home_all_pro?.feproduct
//     ? get_home_all_pro?.feproduct
//     : [];
//   var settings = {
//     dots: false,
//     infinite: true,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     speed: 500,
//     slidesToShow:
//       get_home_all_pro?.feproduct?.length == 1
//         ? 1
//         : get_home_all_pro?.feproduct?.length > 6
//           ? 6
//           : get_home_all_pro?.feproduct?.length - 1,
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow:
//             get_home_all_pro?.feproduct?.length == 1
//               ? 1
//               : get_home_all_pro?.feproduct?.length > 4
//                 ? 4
//                 : get_home_all_pro?.feproduct?.length - 1,
//           slidesToScroll: 3,
//           infinite: true,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow:
//             get_home_all_pro?.feproduct?.length == 1
//               ? 1
//               : get_home_all_pro?.feproduct?.length > 3
//                 ? 3
//                 : get_home_all_pro?.feproduct?.length - 1,
//           slidesToScroll: 2,
//           initialSlide: 2,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow:
//             get_home_all_pro?.feproduct?.length == 1
//               ? 1
//               : get_home_all_pro?.feproduct?.length > 2
//                 ? 2
//                 : get_home_all_pro?.feproduct?.length - 1,
//           slidesToScroll: 1,
//         },
//       },
//     ],
//   };

//   const [windowWidth, setWindowWidth] = useState(600);

//   useLayoutEffect(() => {
//     function handleResize() {
//       setWindowWidth(window.innerWidth);
//     }
//     setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);
//   return (
//     <div>
//       <div className="ps-deal-of-day shewBox">
//         <div className="ps-container">
//           <div className="ps-section__header">
//             <div className="ps-block--countdown-deal">
//               <div className="ps-block__left">
//                 <b>
//                   {" "}
//                   <h3>Featured Product</h3>
//                 </b>
//               </div>
//             </div>
//             <Link to="/products">View all</Link>
//           </div>
//           <div className="ps-section__content mt-10">
//             {recentProduct?.length > 0 && (
//               <Slider {...settings}>
//                 {recentProduct &&
//                   recentProduct?.map((data, i) => {
//                     return (
//                       <div className="recentlostfound" key={i}>
//                         <div className="ps-product">
//                           <div className="ps-product__thumbnail">
//                             <Link to={"/product/" + data?.pro_sulg}>
//                               <CoustomImg
//                                 url={URL.API_BASE_URL + data?.featureImage}
//                                 altkey={data?.title}
//                                 w1={200}
//                                 w2={250}
//                                 h1={160}
//                                 h2={220}
//                               />
//                             </Link>
//                           </div>
//                           <div className="ps-product__container">
//                             <div className="ps-product__content">
//                               <Link
//                                 className="ps-product__title"
//                                 to={"/product/" + data?.pro_sulg}
//                               >
//                                 <TruncateText
//                                   text={data?.title}
//                                   maxLength={windowWidth > 600 ? 25 : 15}
//                                 />
//                               </Link>

//                               <p className="ps-product__price sale">
//                                 ${data?.afterdiscountprice}{" "}
//                                 <del>${data?.price} </del>
//                               </p>
//                               <Link
//                                 className="ps-product__vendor"
//                                 to={"/vendor-store/" + data?.sellerId?._id}
//                               >
//                                 {data?.sellerId?.displayName}
//                               </Link>

//                               <p>
//                                 <span>
//                                   <i>
//                                     <svg
//                                       xmlns="http://www.w3.org/2000/svg"
//                                       viewBox="0 0 24 24"
//                                       width="18"
//                                       height="18"
//                                     >
//                                       <path
//                                         d="M18.364 17.364L12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364ZM12 15C14.2091 15 16 13.2091 16 11C16 8.79086 14.2091 7 12 7C9.79086 7 8 8.79086 8 11C8 13.2091 9.79086 15 12 15ZM12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13Z"
//                                         fill="rgba(240,187,64,1)"
//                                       ></path>
//                                     </svg>
//                                   </i>
//                                 </span>
//                                 {data?.sellerId?.district},
//                                 {data?.sellerId?.state}
//                               </p>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//               </Slider>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default FeProduct;
